(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/pay-vouchers.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/pay-vouchers.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$tur$pay = svs.tur.pay,
  accountServices = _svs$tur$pay.account_services,
  dialogs = _svs$tur$pay.dialogs;
const buyPersonalVouchers = async voucher => {
  const count = voucher.count,
    productId = voucher.productId,
    skinId = voucher.skinId,
    skinPosition = voucher.skinPosition;
  return await svs.tur.apiCaller.ticketgames.postPersonalVouchers({
    data: {
      products: [{
        count,
        productId,
        skinId,
        skinPosition
      }]
    }
  });
};
const createTransactionItems = _ref => {
  let name = _ref.name,
    price = _ref.price,
    count = _ref.count,
    type = _ref.type;
  return Array.from({
    length: count
  }).map(() => ({
    type: 'VOUCHER',
    name,
    price,
    extraData: {
      gameType: type
    }
  }));
};
const buyVouchers = async _ref2 => {
  let next = _ref2.next,
    voucher = _ref2.voucher,
    totalCost = _ref2.totalCost;
  let vouchers = [];
  let failure = false;
  svs.ui.loader.show();
  try {
    const data = await buyPersonalVouchers(voucher);
    vouchers = data.response.giftedVouchers;
    svs.tur.pay.logger.info('Voucher payment success', voucher.productId);
    svs.ticketgames.ticketUtility.logger.info("voucher purchase success, voucherId: ".concat(voucher.productId, ", price: ").concat(totalCost, ", count: ").concat(voucher.count));
    svs.ticketgames.ticketUtility.utils.tracking.trackValidatePurchaseTransactions(createTransactionItems(voucher), vouchers[0].MultiBuyId);
  } catch (e) {
    failure = true;
    svs.tur.pay.logger.error("Voucher payment of ".concat(voucher.productId, " failed: ").concat(e));
    svs.ticketgames.ticketUtility.logger.error("voucher purchase failure, voucherId: ".concat(voucher.productId, ", price: ").concat(totalCost, ", reason: ").concat(JSON.stringify(e)));
  }
  svs.ui.loader.hide();
  next({
    vouchers,
    failure
  });
};
function handleBuyVouchersResult(_ref3) {
  let next = _ref3.next,
    vouchers = _ref3.vouchers,
    failure = _ref3.failure;
  if (!vouchers.length || Boolean(failure)) {
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      type: svs.ui.dialog.type.ERROR,
      icon: 'exclamation-sign',
      title: 'Köp misslyckades',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        align: svs.ui.dialog.message.align.CENTER,
        text: 'Försök igen. Om problemet kvarstår, kontakta Kundservice. Telefon 0770-11 11 11.'
      }],
      actions: [{
        title: 'Okej',
        callback: (e, forms, dialog) => {
          dialog.close();
          next();
        }
      }]
    }));
  } else {
    next();
  }
}
const payVouchers = _ref4 => {
  let voucher = _ref4.voucher,
    _ref4$shouldConfirmPa = _ref4.shouldConfirmPayment,
    shouldConfirmPayment = _ref4$shouldConfirmPa === void 0 ? true : _ref4$shouldConfirmPa,
    onCancel = _ref4.onCancel,
    onDone = _ref4.onDone;
  const value = voucher.value,
    name = voucher.name;
  let vouchers = [];
  let failure = false;
  if (!(voucher !== null && voucher !== void 0 && voucher.count)) {
    return;
  }
  const totalCost = svs.utils.format.CurrencyFromJupiterString(value);
  const confirmPaymentOptions = {
    title: "Vill du betala ".concat(name, " f\xF6r ").concat(totalCost, " kr?"),
    messages: ['Observera att spelet inte går att annullera.']
  };
  const product = voucher === null || voucher === void 0 ? void 0 : voucher.branding;
  let accountBalance;
  const calls = [{
    in: () => ({
      price: totalCost,
      product
    }),
    fn: accountServices.playerSession
  }, {
    in: () => ({
      spelpausFlags: [accountServices.playerSpelpaus.CONSTANTS.QUICK_GAMES]
    }),
    fn: accountServices.playerSpelpaus
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => ({
      price: totalCost,
      product
    }),
    fn: accountServices.accountBalance,
    out: args => {
      var _args = args;
      accountBalance = _args.accountBalance;
      return _args;
    }
  }, {
    fn: accountServices.playerDepositLimits
  }, ...(shouldConfirmPayment ? [{
    in: () => _objectSpread({
      price: totalCost,
      accountBalance
    }, confirmPaymentOptions),
    fn: dialogs.confirmPayment
  }] : []), {
    in: () => ({
      voucher,
      totalCost
    }),
    fn: buyVouchers,
    out: args => {
      var _args2 = args;
      vouchers = _args2.vouchers;
      failure = _args2.failure;
      return _args2;
    }
  }, {
    in: () => ({
      vouchers,
      failure
    }),
    fn: handleBuyVouchersResult
  }];
  const cancel = () => {
    onCancel === null || onCancel === void 0 || onCancel();
  };
  const done = () => {
    onDone === null || onDone === void 0 || onDone({
      vouchers,
      failure
    });
  };
  svs.tur.pay.initPay({
    calls,
    cancel,
    done
  });
};
setGlobal('svs.ticketgames.ticketUtility.payVouchers', payVouchers);

 })(window);